import {_delete, _get, _post, _put} from "@api/doinsport/services/httpService";

const URI = 'clubs/playgrounds/timetables/blocks/payment-token-prices';

export const postBlockPricePaymentTokenPrice = (blockPricePaymentTokenPrice) => _post(URI, blockPricePaymentTokenPrice);

export const putBlockPricePaymentTokenPrice = (blockPricePaymentTokenPrice) => _put(URI + '/' + blockPricePaymentTokenPrice.id, blockPricePaymentTokenPrice);

export const deleteBlockPricePaymentTokenPrice = (id) => _delete(URI + '/' + id);
